<!--
// app/components/Shared/slider-matches/CurrentSeasonSliderMatchesTeam.vue
-->
<script setup lang="ts">
import type { Season } from "#shared/season-cluster/domain/models/01.Season";
import type { MatchCenterData } from "#shared/match/domain/models/Match";
import SliderMatches from "~/components/Shared/slider-matches/SliderMatches.vue";
import SliderArrowsBehaviour from "~/components/Shared/slider-matches/SliderArrowsBehaviour.vue";
import { useSeasons } from "~/composables/season/seasons";
import { useTeams } from "~/composables/teams";
import ButtonEcalSync from "~/components/Shared/ButtonEcalSync.vue";
import regionUiService from "#shared/region/infrastructure/ui-services/regionUiService";

type Props = {
  teamId: number;
  teamSeasons: Season[] | undefined;
  regionReference?: number;
  withAddToCalendarInSection?: boolean;
};

const props = defineProps<Props>();

const { getSeasonTeams, useFetchParamsSeasonMatchCenterData } = useSeasons();
const { teamArrToObjById, findTeamCurrentOrRecentSeason } = useTeams();
const { findRegionInfoByRegionId } = regionUiService();
const { locale } = useI18n();

const currentOrRecentTeamSeason = props.teamSeasons
  ? findTeamCurrentOrRecentSeason(props.teamSeasons)
  : undefined;
const currentOrRecentTeamSeasonTeams = currentOrRecentTeamSeason
  ? await getSeasonTeams(currentOrRecentTeamSeason.id)
  : [];

const teamsObj = await teamArrToObjById(currentOrRecentTeamSeasonTeams, currentOrRecentTeamSeason?.id);

const { path, opts } = useFetchParamsSeasonMatchCenterData(
  currentOrRecentTeamSeason?.id,
  locale.value,
  props.teamId
);
const { data, error } = await useFetch(path, opts);

if (error.value) {
  console.error(error.value);
}

const seasonTurns: MatchCenterData[] = currentOrRecentTeamSeason ? data.value : undefined;

const regionEcalWidgetId = findRegionInfoByRegionId(props.regionReference, "ecalWidgetId");
</script>

<template>
  <div class="px-4 md:px-6 pb-8" v-if="seasonTurns.length">
    <p class="kql-page-section-title flex items-baseline justify-between">
      {{ $t("teams.nextMatches.title") }}
      <button-ecal-sync
        v-if="withAddToCalendarInSection"
        in-title
        :widget-id="regionEcalWidgetId"
      ></button-ecal-sync>
    </p>
    <hr />
  </div>
  <slider-arrows-behaviour
    slider-container-id="matchesSlider"
    :conditionally-render-if="!!seasonTurns.length"
    button-left-id="buttonLeft"
    button-right-id="buttonRight"
    :button-scroll-distance="170"
  >
    <slider-matches
      v-if="seasonTurns.length"
      :phase-turns="seasonTurns"
      :teams="teamsObj"
      :region-reference="regionReference"
    ></slider-matches>
  </slider-arrows-behaviour>
</template>

<style scoped></style>
